/**
 * Selettore IT/EN in alto a destra (e nella pagina di accesso). La scelta resta nel browser e, se l'utente è entrato,
 * nella sua preferenza sul server (ui-prefs `lang`), che vince sul browser a ogni accesso: vedi useLinguaUtente.
 */
import { Segmented } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import type { Lingua } from "@qa/shared";
import { CHIAVE_LINGUA, isLingua, ricordaNelBrowser } from "../i18n/lingua";

const URL_PREFS = "/api/me/ui-prefs";

async function salvaSulServer(l: Lingua) {
  try {
    await fetch(URL_PREFS, { method: "PUT", credentials: "same-origin", headers: { "content-type": "application/json" }, body: JSON.stringify({ prefs: { [CHIAVE_LINGUA]: l } }) });
  } catch {
    /* la scelta resta comunque nel browser */
  }
}

export function SelettoreLingua({ connesso }: { connesso: boolean }) {
  const { i18n, t } = useTranslation();
  const scegli = (l: Lingua) => {
    void i18n.changeLanguage(l);
    ricordaNelBrowser(l);
    if (connesso) void salvaSulServer(l);
  };
  return (
    <Segmented<Lingua>
      size="small"
      aria-label={t("barra.lingua")}
      value={i18n.language === "it" ? "it" : "en"}
      onChange={scegli}
      options={[
        { value: "it", label: "IT" },
        { value: "en", label: "EN" },
      ]}
    />
  );
}

/** Dopo l'accesso: la lingua salvata dall'utente (se c'è) vince su quella del browser. */
export function useLinguaUtente(utenteId: string | undefined) {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (!utenteId) return;
    let vivo = true;
    fetch(URL_PREFS, { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d: { prefs?: Record<string, string> } | null) => {
        const l = d?.prefs?.[CHIAVE_LINGUA];
        if (vivo && isLingua(l) && l !== i18n.language) {
          void i18n.changeLanguage(l);
          ricordaNelBrowser(l);
        }
      })
      .catch(() => {});
    return () => {
      vivo = false;
    };
  }, [utenteId, i18n]);
}
